/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
document.addEventListener('DOMContentLoaded', () => {

	const buttons = document.querySelectorAll('.faq-block__button');

	buttons.forEach((button) => {

		button.addEventListener('click', () => {

			const heading = button.closest('.faq-block__item-heading');
			const panel = heading.nextElementSibling;
			const icon = button.querySelector('.faq-block__icon');

			const isOpen = panel.classList.contains('is-open');

			panel.classList.toggle('is-open', !isOpen);

			button.setAttribute(
				'aria-expanded',
				String(!isOpen)
			);

			icon.textContent = isOpen ? '+' : '−';

		});

	});

});
/* eslint-enable no-console */
